import { inheritSerialization, autoserializeAs } from 'cerialize'

export default class Payee {

  @autoserializeAs('name')
  public name: string = ''

  @autoserializeAs('address')
  public address: string = ''

  @autoserializeAs('tax_id')
  public taxId: string = ''

  @autoserializeAs('vat_inclusive')
  public vatInclusive: boolean = false

  public constructor(public code: string) {
  }
}
